/**
 * Takes an array of directory names and a trailing file name and produce a path delimited by "/"
 */
export function encodePath(arr: string[]): string {
  return arr.map((i) => encodeURIComponent(i.replace(/ /g, "_"))).join("/");
}
